var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.page.path)?_c(_vm.page.hardRedirect ? 'a' : 'router-link',{tag:"Component",attrs:{"href":_vm.page.hardRedirect ? _vm.page.path : null,"to":_vm.page.hardRedirect ? null : _vm.page.path}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }